import type { ChangeEvent } from 'react'
import { useTranslation } from 'react-i18next'

import { CompanySearchField } from '@features/companies/elements/CompanySearchField'
import { Company, FrenchCompany } from '@modules-deprecated/app/companies/types'

import { useFormContext } from '../../../../../../../../../../../../../../../../hooks/useForm'
import type { SupplierFormSchema } from '../../../../../../../../types/supplierForm'

interface CompanyRegistrySearchFieldProps {
  onSelectCompany: (company: Partial<Company> | Partial<FrenchCompany>) => void
}

// CompanySearchField is a Billy design system field, so it stays on the Billy context inside the Lumen form.
export const CompanyRegistrySearchField = ({ onSelectCompany }: CompanyRegistrySearchFieldProps) => {
  const { t } = useTranslation()
  const { FormItem } = useFormContext<SupplierFormSchema>()

  return (
    <FormItem
      label={t('suppliers.detail.form.company_name.label')}
      name="name"
      render={({ field }) => (
        <CompanySearchField
          autoFocus={false}
          error={field.error}
          id={field.id}
          // CompanySearchField types onChange as both a string callback and an input event handler.
          onChange={(companyName: string | ChangeEvent<HTMLInputElement>) => {
            if (typeof companyName === 'string') {
              field.onChange(companyName)
            }
          }}
          onSelectCompany={onSelectCompany}
          size="sm"
          value={field.value}
        />
      )}
    />
  )
}
